import Step from 'components/global/Step'
import Text from 'components/shared/Text'
import Reservation from 'components/shared/Reservation'
import { FormattedMessage, useIntl } from 'react-intl'
import ShortcutTiles from './ShortcutTiles'
import BookAttractions from './BookAttractions'
import { useAppSelector } from 'store/hooks'
import Button from 'components/shared/Button'
import { useNavigate } from 'react-router-dom'
import Box from 'components/shared/Box'
import { useRevertChangesMutation } from 'store/api-slice/hooks'
import { useEffect } from 'react'
import { useApp } from 'store/steps'
import { useSelfcare } from 'store/selfcare-slice/hooks'
import { setIsRevertLoading } from 'store/selfcare-slice'
import { useDispatch } from 'react-redux'

const Starter = () => {
    const { formatMessage } = useIntl()
    const { cabanas, memoryCapture, transport } = useAppSelector(
        (state) => state.selfcare
    )
    const { isCartCreated, countChanges } = useAppSelector(
        (state) => state.selfcareCart
    )
    const navigate = useNavigate()
    const { language } = useApp()
    const { refetchPositions } = useSelfcare()
    const dispatch = useDispatch()

    const [resetSelfcareChanges, status] = useRevertChangesMutation()
    const { isLoading: isRevertLoading } = status

    useEffect(() => {
        countChanges > 0 && resetSelfcareChanges({ _locale: language })
    }, [])

    useEffect(() => {
        dispatch(setIsRevertLoading(isRevertLoading))
        if (isRevertLoading) return
        refetchPositions()
    }, [isRevertLoading])

    const isUpsellInOrder =
        transport?.length || !!cabanas?.length || !!memoryCapture?.length

    return (
        <Step
            title={formatMessage({
                id: 'selfcare.steps.caption_starter',
                defaultMessage: 'Co chcesz zrobić?',
            })}
            isButtonDisabled={false}
            isButtonVisible={false}
            isNarrow={true}
        >
            {isCartCreated && (
                <>
                    <ShortcutTiles />
                    {!isUpsellInOrder && <BookAttractions />}

                    <Text
                        variant="heading2"
                        color="secondary_500"
                        id="reservation_details"
                    >
                        <FormattedMessage
                            id="selfcare.starter.your_reservation"
                            defaultMessage="Twoja rezerwacja"
                        />
                    </Text>
                    <Reservation />
                </>
            )}
            {isCartCreated === false && (
                <Box gap={24}>
                    <Text variant="body" color="grayscale_900">
                        You are not logged in or such a reservation does not
                        exist!
                    </Text>
                    <Button onClick={() => navigate('/modal')}>
                        Go to selfcare login
                    </Button>
                </Box>
            )}
        </Step>
    )
}

export default Starter
